import { combineReducers, AnyAction } from "redux";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import authReducer from "./auth/auth.reducer";
import { zakatReducerV2 } from "./zakatV2/zakat.reducer";
import { charityReducerV2 } from "./charity/charity.reducer";
import { investorReducer } from "./investor/investor.reducer";
import { logoutAction } from "@components/Login/actions";

const authPersistConfig = {
  key: "auth",
  storage,
  whitelist: ["isAuthenticated"],
};

const reducers = {
  auth: persistReducer(authPersistConfig, authReducer),
  zakat: zakatReducerV2,
  investor: investorReducer,
  charity: charityReducerV2,
};

const appReducer = combineReducers(reducers);

const rootReducer = (state: RootState | undefined, action: AnyAction) => {
  if (action.type === logoutAction.fulfilled.type) {
    state = undefined; // Reset the state
  }
  return appReducer(state, action);
};

export type RootState = ReturnType<typeof appReducer>;


export default rootReducer;
